import styled from 'styled-components';

import { Text as TextLayoutComponent, Segment as SegmentLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  width: ${({ increaseWidth }) => (increaseWidth ? '450px' : '325px')};
  margin-top: 70px;
  margin-left: auto;
  margin-right: auto;
    @media screen and (max-width: 991px) {
    width: 80%;
  };
`;

export const ContainerIcons = styled.div`
  display: flex;
  display: row;
  margin-top: 10px;
`;

export const ContainerStep = styled.div`
  display: flex;
`;

export const DownloadIcon = styled.img`
  width: 125px;
  margin: 0 10px;
  object-fit: contain;
`;

export const TimerDescription = styled(TextLayoutComponent)`
  width: max-content;
  flex-wrap: nowrap;
  padding-left: 5px;
`;

export const Text = styled(TextLayoutComponent)``;

export const Segment = styled(SegmentLayoutComponent)`
  &&& {
    margin-bottom: 10px;
  }
`;

export const TextStep = styled(TextLayoutComponent.Bold)`
  margin-bottom: 5px;
`;

export const Label = styled(TextLayoutComponent.Bold)`
  margin-top: 5px;
`;

export const TextTitle = styled(TextLayoutComponent)`
  margin-bottom: 10px;
`;

export const SegmentTopContainer = styled.div`
  display: flex;
`;

export const HelpLink = styled.a``;

export const Spacer = styled.div`
  display: flex;
  flex: 1;
`;

export const ContainerBottom = styled.div`
  text-align: center;
`;
